// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__8J5Ht","inner":"Footer_inner__279Mn"};